/**
 * Width of the icon container rendered at the start of each tree item content, in px.
 * The item loader rows render a gutter with the same width to keep the label placeholders
 * aligned with the tree item labels.
 */
export const TREE_ITEM_ICON_CONTAINER_WIDTH_PX = 16;
